<!--Horizontal Timeline Starts-->
<div class="row">
    <div class="col-sm-12">
        <div class="content-header">Horizontal Timeline</div>
        <p class="content-sub-header">This horizontal timeline contain date based post timeline.</p>
    </div>
</div>
<div class="card">
	<div class="card-content">
		<div class="card-body">
			<horizontal-timeline [timelineElements]="timeline" [showContent]="true"></horizontal-timeline>
		</div>
	</div>
</div>
<!--Horizontal Timeline Starts-->